import { route } from 'preact-router';
import { error, success } from '../store/state';
import { crearAdmin } from '../store/actions/user.actions';
import { Shell } from '../layout/Shell';
import { Icon } from '../components/Icon';

export function AdminFormView() {
  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const payload = Object.fromEntries(fd);
    try {
      await crearAdmin(payload);
      success.value = 'Administrador creado.';
      route('/perfil');
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="perfil">
      <h2>Nuevo administrador</h2>
      <p class="muted" style={{ margin: '0 0 16px' }}>
        Va a tener el mismo nivel de acceso que vos: puede gestionar clientes, técnicos y ver
        todas las visitas de la empresa.
      </p>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Nombre</label>
        <input name="nombre" required />
        <label>Email</label>
        <input name="email" type="email" required />
        <label>Contraseña</label>
        <input name="password" type="password" required minLength={6} />
        <label>Teléfono</label>
        <input name="telefono" />
        <button class="primary" type="submit">
          <Icon name="user-plus" size={16} />
          Crear administrador
        </button>
        <button class="secondary" type="button" onClick={() => route('/perfil')}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
